import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

import { BOX_SHADOW_PRIMARY } from '@/designSystem/theme';

export default makeStyles()(({ palette, border }) => ({
  root: {
    display: 'flex',
    gap: rem(8),
    margin: 0,
  },
  checkbox: {
    width: rem(24),
    height: rem(24),
    borderRadius: rem(8),
    padding: rem(0),
    border: border[700],
    background: 'white',
    color: 'transparent',
    boxShadow: 'none',
    '&:hover': {
      border: `1px solid var(--forms-input-border-active, ${palette.primary.main})`,
      background: 'white',
      boxShadow: BOX_SHADOW_PRIMARY,
    },
    '&.Mui-checked': {
      border: `1px solid var(--forms-input-border-active, ${palette.primary.main})`,
      background: `var(--forms-input-border-active, ${palette.primary.main})`,
      color: 'white',
    },
  },
}));
